import request from '@/utils/request'
const apiPath = '/sys/cityCompanyQrcode'
const cityCompanyQrcodeApi = {
  /**
   * 分页查询【城市公司静态码列表】
   */
  fetchList(query) {
    return request.get(`${apiPath}/teev2`, {
      params: query
    })
  },
  /**
   * 新增【城市公司静态码】
   */
  create(data) {
    return request.post(`${apiPath}/teev2`, data)
  },
  /**
   * 修改【城市公司静态码】
   */
  update(data) {
    return request.put(`${apiPath}/teev2`, data)
  },
  /**
   * 修改状态【城市公司静态码】
   */
  setEnable(data) {
    return request.post(`${apiPath}/teev2/setEnable`, data)
  }
}
export default cityCompanyQrcodeApi

